module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('b-container', [_c('b-row', {
    staticClass: "pt-2"
  }, [_c('b-col', {
    staticClass: "pt-2 mini-menu",
    attrs: {
      "lg": "3",
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-nav', {
    attrs: {
      "vertical": ""
    }
  }, _vm._l((_vm.categorias), function(categoria) {
    return _c('b-nav-item', {
      key: categoria.id,
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.loadProducts(1, categoria.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(categoria.nome) + "\n                    ")])
  }))], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pt-2",
    attrs: {
      "lg": "9",
      "md": "12",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l((_vm.produtos), function(produto) {
    return _c('router-link', {
      key: produto.prdno.trim(),
      attrs: {
        "to": "/seja-um-parceiro/acesso"
      }
    }, [_c('div', {
      staticClass: "item col-lg-3 col-md-2 col-sm-1 text-center"
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": produto.grades[0].url_miniatura,
        "alt": produto.grades[0].nome
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info text-justify"
    }, [_c('h3', [_vm._v(_vm._s(produto.nome))])])])])
  })), _vm._v(" "), (_vm.totalPages >= 1) ? _c('b-pagination-nav', {
    attrs: {
      "align": "center",
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.totalPages
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Produtos ")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Esta oportunidade é para você e seu negócio!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d67871","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/Produtos.vue
// module id = 875
// module chunks = 0